import { Select, Typography } from '@telavita-core/react-design-kit'
import React, { FC, ReactNode } from 'react'
import { ReactComponent as TrashSvg } from 'static/svg/icon-trash.svg'
import * as S from './styles'

type OptionDetails = {
  id: string | number
  label: string
}

interface OptionDetailsSelectProps {
  id: string | number
  nameId?: string
  name?: string
  value: OptionDetails
  options: OptionDetails[]
  placeholder?: string
  onChange: (value: OptionDetails) => void
  onRemoveOption?: (id: string | number) => void
  otherInput?: ReactNode
  disabled?: boolean
  messageError?: string
  noStatus?: boolean
}

export const OptionDetailsSelect: FC<OptionDetailsSelectProps> = ({
  id,
  nameId = '',
  name,
  value,
  options,
  onChange,
  onRemoveOption,
  placeholder,
  otherInput,
  disabled,
  messageError,
  noStatus
}) => {
  return (
    <S.OptionDetailsSelectContainer>
      {name && <Typography variant='content2'>{name}</Typography>}
      <S.OptionDetailsSelectOtherContainer>
        {otherInput}
        <S.OptionDetailsSelectStatusWrapper id={`${nameId}-${id}`}>
          {!noStatus && (
            <Select
              label=''
              placeholder={placeholder}
              onSelect={(valueSelected) => onChange(valueSelected)}
              options={options}
              selected={value}
              disabled={disabled}
              hasError={Boolean(messageError)}
              messageError={messageError}
            />
          )}
          {onRemoveOption && (
            <TrashSvg
              role='button'
              width={48}
              onClick={() => onRemoveOption(+id)}
            />
          )}
        </S.OptionDetailsSelectStatusWrapper>
      </S.OptionDetailsSelectOtherContainer>
    </S.OptionDetailsSelectContainer>
  )
}
